// Restored from the practice's WordPress post 34320, published May 19, 2026.
export const invisalignArticlePath =
	"/why-patients-are-choosing-invisalign-in-miami-top-reasons";
export const invisalignArticleTitle = "Why Patients Are Choosing Invisalign";
export const invisalignArticleDescription =
	"Discover why patients are choosing Invisalign over traditional braces. Explore the benefits, process, costs, and candidacy factors driving this clear aligner trend.";

export const invisalignArticleFaqs = [
	{
		question: "How long does Invisalign treatment take?",
		answer:
			"Most patients complete treatment in 6 to 18 months. Simple cases like minor crowding may finish faster, while more complex alignment issues take longer. Dr. Garcia-Paul will give you a timeline estimate during your consultation based on your specific needs.",
	},
	{
		question: "Does Invisalign hurt?",
		answer:
			"You’ll feel mild pressure for the first few days after switching to a new aligner. This means your teeth are moving. Most people describe it as tightness rather than discomfort. The feeling fades quickly as your mouth adjusts.",
	},
	{
		question: "Can I eat with Invisalign in?",
		answer:
			"No. Remove your aligners for all food and drinks except water. This protects the aligners from damage and staining. Pop them back in after you eat and brush your teeth.",
	},
	{
		question: "How often do I clean my aligners?",
		answer:
			"Clean your aligners daily. Rinse them every time you remove them, and brush them gently with a soft toothbrush. Avoid hot water, which can warp the plastic. Some patients use Invisalign cleaning crystals for a deeper clean.",
	},
	{
		question: "Will Invisalign affect my speech?",
		answer:
			"Some people notice a slight lisp during the first few days. This is temporary. Your tongue adjusts to the aligners quickly, usually within a week.",
	},
	{
		question: "What happens if I lose an aligner?",
		answer:
			"Contact Miami Orthodontic Specialists right away. Depending on where you are in treatment, you may move to your next set early or need a replacement aligner. Don’t skip ahead without guidance from Dr. Garcia-Paul.",
	},
];
